export class BaseModel {
    public FechaAlta: Date;
    public FechaModificacion: Date;
    public FechaBaja: Date;

    public BaseModel() { }
}